export default {
  // Formulario - textos únicos
  minutesPerPedagogicalHour: 'Minutos por Hora Pedagógica',

  // Mensajes - textos únicos
  deleteConfirmTitle: '¿Está seguro de que desea eliminar el Tipo de Perfil de Egreso?',
  deletedMessage: 'Tipo de Perfil de Egreso eliminada.',
  cannotDeleteWithEntity: 'No se puede eliminar la {entity1} si cuenta con {entity2}',
}
